module.exports = __webpack_public_path__ + "img/profess3.4061e94a.png";